import "./App.css";

function App() {
  return (
    <div className="App">
      <iframe
        title="Formhouse Creative"
        src="/formhouse.html"
        className="site-frame"
      />
    </div>
  );
}

export default App;
